<template>
  <div class="h-100 chat-center-container">
    <v-layout row wrap h-100>
      <v-flex xs2>
        <v-navigation-drawer class="drawer elevation-3" :value="true" permanent floating stateless>
          <v-toolbar flat class="transparent">
            <v-container grid-list-lg fluid>
              <v-layout row wrap justify-center align-center>
                <v-flex xs12>
                  <v-layout row wrap mb-2>
                    <v-flex py-0>
                      <h3>
                        {{ user.first_name }} {{ user.last_name }}
                      </h3>
                      <small class="text-truncate">
                        {{ user.email }}
                      </small>
                    </v-flex>
                  </v-layout>
                  <toggle-button :value="true"
                    :width="70"
                    :color="{ checked: '#75c791', unchecked: '#ff6e6e' }"
                    :labels="{checked: 'online', unchecked: 'offline'}"
                    v-model="isConnected"
                    :disabled="ajaxOn"
                    :sync="true"
                    @input="toggleConection"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-toolbar>
          <v-divider></v-divider>
          <v-container grid-list-lg py-0>
            <v-layout row wrap>
              <v-flex xs12 class="mt-1">
                <side-btn
                  to="/chat_center/"
                  size="md"
                  icon="fas fa-comments"
                  :active="$route.name === 'ChatCenterV2'">
                  Chat center
                </side-btn>
              </v-flex>
            </v-layout>
            <v-layout v-if="canSeeChatCenterWhatsapp" row wrap>
              <v-flex xs12 class="mt-1" >
                <side-btn
                  to="/chat_center/inbox"
                  size="md"
                  icon-component="InboxOutIcon"
                  :active="$route.name === 'ChatCenterV2Inbox'">
                  Bandeja principal
                </side-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 class="mt-1">
                <side-btn
                v-if="checkPermissionsDashboards"
                  to="/chat_center/dashboard"
                  size="md"
                  icon="comments"
                  :active="$route.name === 'ChatCenterReportV2'">
                  Dashboard
                </side-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 class="mt-1">
                <side-btn
                  to="/chat_center/config"
                  size="md"
                  icon="settings"
                  :active="$route.name === 'ChatCenterV2Config'">
                  Configuraciones
                </side-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 class="mt-1">
                <side-btn
                  size="md"
                  icon="lightbulb"
                  :active="showIntentions"
                  @click.native="toggleIntentions">
                  Intenciones 
                </side-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="intention-container">
              <v-flex xs12 py-0>
                <v-expansion-panel expand>
                  <v-expansion-panel-content :value="showIntentions">
                    <vue-perfect-scrollbar ref="chatRoomScrollbar" v-if="intentions.length">
                      <v-list class="intention-list">
                        <v-list-tile avatar v-for="(item, index) in intentions" :key="`intention-${index}`">
                          <v-list-tile-action>
                            <v-checkbox v-model="intentionChecks" :value="item.id" @change="changeFilters"></v-checkbox>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              <small>
                                {{ item.name }}
                              </small>
                              <small class="smaller">
                                ({{ item.qty }})
                              </small>
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </vue-perfect-scrollbar>
                    <info min-height="50px" v-else>
                      No se encontraron intenciones
                    </info>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>
          </v-container>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs10 class="position-relative">
        <transition name="fade-effect" mode="out-in">
          <router-view :key="`chat-center-${$router.path}`"></router-view>
        </transition>
      </v-flex>
    </v-layout>
    <alert-modal class="alert-modal" icon-style="font-size: 3em" content-class="my-3" :show="showInactive" @close="showInactive = false">
      <template slot="content">
        <span >
          Desconexión automatica por inactividad
        </span>
      </template>
    </alert-modal>
  </div>
</template>
<script>

import _ from 'lodash';
import { mapGetters } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import EventBus from '@/event-bus';
import { ToggleButton } from 'vue-js-toggle-button';
import AlertModal from '@/components/global/AlertModal';
import Info from '@/components/global/Info';
import SideBtn from './Button';
import permissionsMixin from '@/mixins/permissions';

const qs = require('qs');

export default {
  components: {
    VuePerfectScrollbar,
    ToggleButton,
    AlertModal,
    SideBtn,
    Info,
  },
  mixins: [
    permissionsMixin,
  ],
  mounted() {
    this.intentionChecks = [
      ...this.intentionFilters,
    ];
    EventBus.$emit('hideMenu');
    this.startListeningEvents();
  },
  beforeDestroy() {
    this.stopListeningEvents();
  },
  data() {
    return {
      // eslint-disable-next-line
      isConnected: this.$auth.user().chat_center_online ? true : false,
      ajaxOn: false,
      showInactive: false,
      showIntentions: false,
      intentionChecks: [],
    };
  },
  computed: {
    ...mapGetters([
      'intentionFilters',
      'menuDrawer',
      'intentions',
    ]),
    user() {
      return this.$auth.user();
    },
    channel() {
      return `company.${this.user.company.id}.chatCenter`;
    },
    url() {
      let url = `chats_center?${qs.stringify(this.filters)}&`;
      url += `limit=${this.limit}&`;
      url += `offset=${this.offset}`;
      return url;
    },
    disconected() {
      return this.user.chat_center_online === 0 || this.user.chat_center_online === false;
    },
    intentionsQty() {
      return this.intentions.reduce((item, x = 0) => x + item.qty);
    },
    checkPermissionsDashboards() {
      return this.checkPermissions([
        'see_chat_center_dashboards',
      ]);
    },
    canSeeChatCenterWhatsapp() {
      return this.checkPermissions([
        'see_chat_center_whatsapp',
      ]);
    },
  },
  methods: {
    startListeningEvents() {
      window.Echo.private(`${this.channel}Report`)
        .listen('.ChangeChatOnlineStatus', (event) => {
          const id = event.user_id || event.id;
          if (id === this.user.id) {
            this.user.chat_center_online = event.chat_center_online;
            if (this.isConnected && !event.chat_center_online) {
              this.showInactive = true;
            }
            this.isConnected = Boolean(event.chat_center_online);
          }
        });
    },
    stopListeningEvents() {
      window.Echo.leave(`${this.channel}Report`);
    },
    toggleConection() {
      this.ajaxOn = true;
      this.axios.post('chat/center/online', {
        status: this.isConnected,
      }).then(({ data }) => {
        this.ajaxOn = false;
        // eslint-disable-next-line
        this.$auth.user().chat_center_online = data.status;
      }).catch(() => {
        this.ajaxOn = false;
        this.isConnected = !this.isConnected;
      });
    },
    toggleIntentions() {
      this.showIntentions = !this.showIntentions;
    },
    // eslint-disable-next-line
    changeFilters: _.debounce(function ($event) {
      this.$store.commit('SET_INTENTION_FILTERS', $event);
    }, 800),
  },
};
</script>

<style scoped>
  .position-relative {
    position: relative;
  }
  .position-absolute {
    position: absolute;
  }
  .drawer {
    width: 100% !important;
    z-index: 1;
    position: relative;
  }
  .navbar-header {
    height: 64px;
  }
  .navbar-footer {
    height: 32px;
  }
  .thumbnail {
    border: 2px solid #d3d3d3;
    height: 64px;
    overflow: hidden;
    border-radius: 6px;
  }
  .img-responsive {
    width: 100%;
  }
  .navigation-drawer >>> .toolbar__content {
    height: 96px !important;
  }
  .semi-border--left {
    position: relative;
  }
  .semi-border--left:before {
    top: 50%;
    left: 1em;
    width: 1px;
    height: 70%;
    border: 1px solid #d3d3d3;
    content: '';
    position: absolute;
    transform: translateY(-50%);
  }
  .chat-center-container >>> .chat-modal {
    max-height: 95% !important; 
    overflow: visible;
  }
  .chat-center-container >>> .chat-config-modal {
    overflow: visible;
  }
  .blured {
    filter: blur(5px);
  }
  .border {
    border: 1px solid #d3d3d3;
    border-radius: 4px;
  }
  .border-bottom {
    border-bottom: 1px solid #d3d3d3;
  } 
  .border-left {
    border-left: 1px solid #d3d3d3;
  }
  .border-right {
    border-right: 1px solid #d3d3d3;
  }
  .fade-enter-active, .fade-leave-active {
    transition: all .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .text-truncate {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .intention-container .expansion-panel {
    box-shadow: 0px 0px 0px 0px transparent;
  } 
  .intention-list {
    height: 175px;
    margin-top: 5px;
  }
  .clickeable {
    cursor: pointer;
  }
  .intention-list >>> .list__tile--avatar {
    padding-left: 0;
    padding-right: 0;
  }
  .intention-list >>> .list__tile--avatar .list__tile__action {
    min-width: 30px;
  }
  .intention-list >>> .list__tile list__tile--avatar {
    height: 30px !important;
  }
</style>





// WEBPACK FOOTER //
// src/components/chat_center_v2/Panel.vue